import { API_CALL_STATUS, FIELD_STATUS, FORM_STATUS } from '../status';

import {
    FIRST_NAME_SET_VALUE,
    FIRST_NAME_SET_VALID,
    LAST_NAME_SET_VALUE,
    LAST_NAME_SET_VALID,
    DOB_SET_VALUE,
    DOB_SET_VALID,
    PHONE_NUMBER_SET_VALUE,
    PHONE_NUMBER_SET_VALID,
    ID_NUMBER_SET_VALUE,
    ID_NUMBER_SET_VALID,
    TIN_NUMBER_SET_VALUE,
    TIN_NUMBER_SET_VALID,
    STREET_ADDRESS_SET_VALUE,
    STREET_ADDRESS_SET_VALID,
    SUBURB_SET_VALUE,
    SUBURB_SET_VALID,
    CITY_SET_VALUE,
    CITY_SET_VALID,
    POSTAL_ADDRESS_SET_VALUE,
    POSTAL_ADDRESS_SET_VALID,
    REINITIALIZE,
    SELECTED_FORM_SET_VALUE,
    FORM_VALID_AFYA_IMARA_SPOUSE_DETAILS_FORM,
    FORM_INVALID_AFYA_IMARA_SPOUSE_DETAILS_FORM,
    API_PENDING_TRANSITION_SPOUSE_DETAILS_FORM,
    API_SUCCESS_TRANSITION_SPOUSE_DETAILS_FORM,
    API_FAILURE_TRANSITION_SPOUSE_DETAILS_FORM,
    SET_ID_DOC_VALUE,
    RESET_SPOUSE_ID_DOC,
    GENDER_SET_VALUE,
    GENDER_SET_VALID,
    MARITAL_STATUS_SET_VALUE,
    MARITAL_STATUS_SET_VALID,
    NIHF_NUMBER_SET_VALUE,
    NIHF_NUMBER_SET_VALID,
} from '../../actions/afyaImara/spouseDetails';

export const initSpouseDetails = {
    formStatus: FORM_STATUS.INVALID,
    apiCallStatus: null,
    selectedForm: 'initial',
    form: {
        firstName: { value: null, error: null, status: null },
        lastName: { value: null, error: null, status: null },
        email: { value: null, error: null, status: null },
        dob: { value: null, error: null, status: null },
        idNumber: { value: null, error: null, status: null },
        phoneNumber: { value: null, error: null, status: null },
        tinNumber: { value: null, error: null, status: null },
        streetAddress: { value: null, error: null, status: null },
        suburb: { value: null, error: null, status: null },
        city: { value: null, error: null, status: null },
        gender: { value: null, error: null, status: null },
        nihfNumber: { value: null, error: null, status: null },
        maritalStatus: { value: null, error: null, status: null },
    },
};

export default (state = initSpouseDetails, action) => {
    const mapError = (error) => (error ? FIELD_STATUS.ERROR : FIELD_STATUS.VALID);
    const updateFormField = (fieldId, update) => ({
        ...state,
        form: {
            ...state.form,
            [fieldId]: update(state.form[fieldId]),
        },
    });

    switch (action.type) {
        case REINITIALIZE:
            return initPersonalDetails;

        case SELECTED_FORM_SET_VALUE:
            return { ...state, selectedForm: action.value };

        case FORM_VALID_AFYA_IMARA_SPOUSE_DETAILS_FORM:
            return { ...state, formStatus: FORM_STATUS.VALID };

        case FORM_INVALID_AFYA_IMARA_SPOUSE_DETAILS_FORM:
            return { ...state, formStatus: FORM_STATUS.INVALID };

        case API_PENDING_TRANSITION_SPOUSE_DETAILS_FORM:
            return { ...state, apiCallStatus: API_CALL_STATUS.PENDING };
        case API_SUCCESS_TRANSITION_SPOUSE_DETAILS_FORM:
            return { ...state, apiCallStatus: API_CALL_STATUS.SUCCESS };
        case API_FAILURE_TRANSITION_SPOUSE_DETAILS_FORM:
            return { ...state, apiCallStatus: API_CALL_STATUS.FAILURE };

        case GENDER_SET_VALUE:
            return updateFormField('gender', (field) => ({
                ...field,
                value: action.value,
            }));

        case GENDER_SET_VALID:
            return updateFormField('gender', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case MARITAL_STATUS_SET_VALUE:
            return updateFormField('maritalStatus', (field) => ({
                ...field,
                value: action.value,
            }));

        case MARITAL_STATUS_SET_VALID:
            return updateFormField('maritalStatus', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case NIHF_NUMBER_SET_VALUE:
            return updateFormField('nihfNumber', (field) => ({
                ...field,
                value: action.value,
            }));

        case NIHF_NUMBER_SET_VALID:
            return updateFormField('nihfNumber', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case SET_ID_DOC_VALUE:
            return updateFormField('idDoc', (field) => ({
                ...field,
                value: action.value,
            }));

        case RESET_SPOUSE_ID_DOC:
            return updateFormField('idDoc', (field) => ({
                ...field,
                value: null,
            }));

        case FIRST_NAME_SET_VALUE:
            return updateFormField('firstName', (field) => ({
                ...field,
                value: action.value,
            }));

        case FIRST_NAME_SET_VALID:
            return updateFormField('firstName', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case LAST_NAME_SET_VALUE:
            return updateFormField('lastName', (field) => ({
                ...field,
                value: action.value,
            }));
        case LAST_NAME_SET_VALID:
            return updateFormField('lastName', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case DOB_SET_VALUE:
            return updateFormField('dob', (field) => ({
                ...field,
                value: action.value,
            }));

        case DOB_SET_VALID:
            return updateFormField('dob', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case PHONE_NUMBER_SET_VALUE:
            return updateFormField('phoneNumber', (field) => ({
                ...field,
                value: action.value,
            }));

        case PHONE_NUMBER_SET_VALID:
            return updateFormField('phoneNumber', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case ID_NUMBER_SET_VALUE:
            return updateFormField('idNumber', (field) => ({
                ...field,
                value: action.value,
            }));

        case ID_NUMBER_SET_VALID:
            return updateFormField('idNumber', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case TIN_NUMBER_SET_VALUE:
            return updateFormField('tinNumber', (field) => ({
                ...field,
                value: action.value,
            }));

        case TIN_NUMBER_SET_VALID:
            return updateFormField('tinNumber', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case STREET_ADDRESS_SET_VALUE:
            return updateFormField('streetAddress', (field) => ({
                ...field,
                value: action.value,
            }));

        case STREET_ADDRESS_SET_VALID:
            return updateFormField('streetAddress', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case CITY_SET_VALUE:
            return updateFormField('city', (field) => ({
                ...field,
                value: action.value,
            }));

        case CITY_SET_VALID:
            return updateFormField('city', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case SUBURB_SET_VALUE:
            return updateFormField('suburb', (field) => ({
                ...field,
                value: action.value,
            }));

        case SUBURB_SET_VALID:
            return updateFormField('suburb', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case POSTAL_ADDRESS_SET_VALUE:
            return updateFormField('postalAddress', (field) => ({
                ...field,
                value: action.value,
            }));

        case POSTAL_ADDRESS_SET_VALID:
            return updateFormField('postalAddress', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        default:
            return state;
    }
};
